import "@Styles/Controls/Print/printHeader_sm.less";
import "@Styles/Controls/Print/PB/printHeader_sm.less";
export default (function (config, elementId) {
  return _initializePrintHeader(elementId);
});

var _initializePrintHeader = function _initializePrintHeader(elementId) {
  var element = document.getElementById(elementId);
  var printButton = element ? element.querySelector(".printButton") : null;

  if (printButton) {
    printButton.onclick = function () {
      var searchParams = new URLSearchParams(window.location.search);
      var position = searchParams.get('position');
      GeneralMills.Analytics && GeneralMills.Analytics.raiseEvent({
        EventType: "Print",
        ContentId: window.utag_data.ContentId,
        ContentTitle: window.utag_data.ContentTitle,
        ContentType: window.utag_data.ContentType,
        RecordType: window.utag_data.RecordType,
        Position: position
      });
      setTimeout(window.print, 1);
    };
  }
};